import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function CoffeeIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            className={cn('fill-current', className)}
            xmlns='http://www.w3.org/2000/svg'
            data-name='Layer 1'
            viewBox='0 0 24 24'
            width={width}
            height={height}
        >
            <path d='M20 10h-.115A3.1 3.1 0 0017 6H3c-5.451.372-2 8.651-.589 10.912A6.877 6.877 0 008.216 20h3.567a6.875 6.875 0 005.742-3H20c4.814-.093 5.759-7.178 0-7zm-8.217 8H8.216a4.881 4.881 0 01-4.131-2.179C3.541 15.3.494 8 3 8h14a.973.973 0 01.729.325 1.028 1.028 0 01.261.8c-.563 4.259-1.622 8.686-6.207 8.875zM20 15h-1.412a16.82 16.82 0 00.954-3c1.209-.081 2.546.216 2.458 1.143A1.984 1.984 0 0120 15zM9.025 3V1a1 1 0 012 0v2a1 1 0 01-2 0zm4 0V1a1 1 0 012 0v2a1 1 0 01-2 0zm-8 0V1a1 1 0 012 0v2a1 1 0 01-2 0zM20 23a1 1 0 01-1 1H1a1 1 0 010-2h18a1 1 0 011 1z' />
        </svg>
    );
}

export default CoffeeIcon;

